export class DeviceBatteryPotential {
    constructor(bp?: DeviceBatteryPotential | null) {
        this.unit = bp?.unit ?? "";
        this.batteryPotential = bp?.batteryPotential ?? 0;
    }

    public unit: string = "";

    public batteryPotential: number = 0;
}